import React, { useState } from 'react';
import './App.css';
import Menu from './Components/Menu/Menu';
import Navbar from './Components/Navbar/Navbar';
import { BrowserRouter as Router,Switch,Route, Redirect} from "react-router-dom";
import Course from './Pages/Course/Course';
import AddCourse from './Pages/AddCourse/AddCourse';
import UpdateCourse from './Pages/UpdateCourse/UpdateCourse';
import CommentsList from './Pages/CommentsList/CommentsList';
import Chat from './Pages/Chat/Chat';
import AccountingPage from './Pages/AccountingPage/AccountingPage';
import Pages from './Pages/Pages/Pages';
import PagesList from './Pages/PagesList/PagesList';

import EditPage from './Pages/EditPage/EditPage';
import AddPage from './Pages/AddPage/AddPage';

function App() {
  const[situation,Setsituation]=useState(false)
    const openMenuHandle=()=>{
        Setsituation(true) 
    }
    const closeMenuHandle=()=>{
        Setsituation(false)
    }



  return (
    <Router>
        <div className="App">
        <section className={'contentHolder'}>
        <Menu setopen={openMenuHandle}/>
        <Switch>
          <PrivateRoute exact path='/' component={Course}/>
          <PrivateRoute exact path='/addcourse' component={AddCourse}/>
          <PrivateRoute exact path='/updatecourse' component={UpdateCourse}/>
          <PrivateRoute exact path='/commentlist' component={CommentsList}/>
          <PrivateRoute exact path='/chat/:id' component={Chat}/>
          <PrivateRoute exact path='/accounting' component={AccountingPage}/>
          <PrivateRoute exact path='/pages' component={Pages}/>
          <PrivateRoute exact path='/pageslist' component={PagesList}/>
          <PrivateRoute exact path='/addpage' component={AddPage}/>
          <PrivateRoute exact path='/editpage/:name' component={EditPage}/>
        </Switch>
        </section>
        <Navbar show={situation} setclose={closeMenuHandle}/>
      </div>
    </Router>
  );
}

const isLogin=()=>!!localStorage.getItem('electronicStepsAdmin')


const PrivateRoute=({component,...props})=>{
  return <Route {...props} render={(props)=>{
    if(isLogin()){
      return React.createElement(component,props)
    }
    else{
      return <Redirect to={'/login'}/>
    }
  }}/>
}
export default App;
